import type { PublicProduct } from '../marketplace/types';

export type StoreFilter = 'all' | 'course' | 'service';

export function getProductTypeLabel(product_type: string): 'COURSE' | 'SERVICE' {
  return product_type === 'scheduled_seats' ? 'COURSE' : 'SERVICE';
}

export function filterByType(products: PublicProduct[], filter: StoreFilter): PublicProduct[] {
  if (filter === 'all') return products;
  if (filter === 'course') return products.filter((p) => p.product_type === 'scheduled_seats');
  return products.filter((p) => p.product_type === 'flat_fee');
}

export function getCourseCount(products: PublicProduct[]): number {
  return products.filter((p) => p.product_type === 'scheduled_seats').length;
}

export function getServiceCount(products: PublicProduct[]): number {
  return products.filter((p) => p.product_type === 'flat_fee').length;
}
